//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { clientConfigLabelEditApi, clientConfigLabelSaveApi, clientConfigSaveApi, invoiceCategory as _invoiceCategory, putInvoiceCategory as _putInvoiceCategory } from '@/api/enterprise';
export default {
  name: 'AddDialog',
  components: {},
  props: {
    repeatData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      rules: {
        title: '',
        sort: 0
      },
      rule: {
        title: [{
          required: true,
          message: this.$t('customer.message02'),
          trigger: 'blur'
        }]
      },
      key: 'cate',
      loading: false
    };
  },
  watch: {
    repeatData: {
      handler: function handler(nVal) {
        if (nVal.label === 1) {
          if (nVal.type === 2) {
            this.rules.title = nVal.data.value.title;
            this.rules.sort = nVal.data.sort;
          }
        } else {
          if (nVal.type === 2) {
            this.rules.title = nVal.data.name;
            this.rules.sort = nVal.data.sort;
          }
        }
      },
      deep: true
    }
  },
  methods: {
    handleClose: function handleClose() {
      this.rules.title = '';
      this.rules.sort = '';
      this.dialogVisible = false;
    },
    confirmData: function confirmData() {
      this.$emit('handleRepeatData', this.rules);
    },
    placeholderFn: function placeholderFn(type) {
      if (type == 1) {
        return this.$t('customer.placeholder03');
      } else if (type == 3) {
        return '请输入类目名称';
      } else {
        return this.$t('customer.placeholder05');
      }
    },
    handleConfirm: function handleConfirm() {
      var _this = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          // 添加分类
          if (_this.repeatData.label === 1) {
            _this.rules.sort = _this.rules.sort === '' ? 1 : _this.rules.sort;
            var id = _this.repeatData.type === 1 ? 0 : _this.repeatData.data.id;
            var data = [{
              title: _this.rules.title,
              sort: _this.rules.sort,
              id: id
            }];
            _this.clientConfigSave({
              data: data,
              key: _this.key
            });
          } else if (_this.repeatData.label === 3) {
            _this.rules.sort = _this.rules.sort === '' ? 1 : _this.rules.sort;
            var id = _this.repeatData.type === 1 ? 0 : _this.repeatData.data.id;
            var data = {
              name: _this.rules.title,
              sort: _this.rules.sort
            };
            if (_this.repeatData.type === 1) {
              _this.invoiceCategory(data);
            } else {
              _this.putInvoiceCategory(_this.repeatData.data.id, data);
            }
          } else {
            // 客户标签
            _this.rules.sort = _this.rules.sort === '' ? 1 : _this.rules.sort;
            if (_this.repeatData.type === 1) {
              _this.labelSave({
                name: _this.rules.title,
                pid: 0,
                sort: _this.rules.sort
              });
            } else {
              _this.labelEdit(_this.repeatData.data.id, {
                name: _this.rules.title,
                pid: 0,
                sort: _this.rules.sort
              });
            }
          }
        }
      });
    },
    // 保存企业设置--客户分类
    clientConfigSave: function clientConfigSave(data) {
      var _this2 = this;
      this.loading = true;
      clientConfigSaveApi(data).then(function (res) {
        _this2.handleClose();
        _this2.$emit('isOk');
        _this2.loading = false;
      }).catch(function (error) {
        _this2.loading = false;
      });
    },
    // 保存发票类目
    invoiceCategory: function invoiceCategory(data) {
      var _this3 = this;
      this.loading = true;
      _invoiceCategory(data).then(function (res) {
        _this3.$emit('isOk');
        _this3.loading = false;
        _this3.handleClose();
      }).catch(function (err) {
        _this3.loading = false;
        _this3.handleClose();
      });
    },
    // 编辑发票类目
    putInvoiceCategory: function putInvoiceCategory(id, data) {
      var _this4 = this;
      this.loading = true;
      _putInvoiceCategory(id, data).then(function (res) {
        _this4.$emit('isOk');
        _this4.loading = false;
        _this4.handleClose();
      }).catch(function (err) {
        _this4.loading = false;
      });
    },
    // 客户标签保存
    labelSave: function labelSave(data) {
      var _this5 = this;
      this.loading = true;
      clientConfigLabelSaveApi(data).then(function (res) {
        _this5.handleClose();
        _this5.$emit('isOk');
        _this5.loading = false;
      }).catch(function (error) {
        _this5.loading = false;
      });
    },
    // 客户标签修改
    labelEdit: function labelEdit(id, data) {
      var _this6 = this;
      this.loading = true;
      clientConfigLabelEditApi(id, data).then(function (res) {
        _this6.handleClose();
        _this6.$emit('isOk');
        _this6.loading = false;
      }).catch(function (error) {
        _this6.loading = false;
      });
    }
  }
};